import Api from './MultiplePhotographersInvoiceApi';
import * as types from './MultiplePhotographersInvoiceActionTypes';

export function clearState(): any {
    return (dispatch: (result: any) => void) =>
        dispatch({ type: types.CLEAR_PHOTOGRAPHER_INVOICE_COLLECTIONS_STATE });
}

function getListsSuccess(list: any) {
    return {
        type: types.GET_PHOTOGRAPHER_INVOICE_COLLECTION_LISTS_SUCCESS,
        result: list
    };
}

export function getLists() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getLists().then((result: any) => {
            dispatch(getListsSuccess(result));
        });
}

function getPhotographerInvoiceCollectionSuccess(invoice: any) {
    return {
        type: types.GET_PHOTOGRAPHER_INVOICE_COLLECTION_SUCCESS,
        result: invoice
    };
}

export function getInvoiceCollection(type: string) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getInvoiceCollection(type).then((result: any) => {
            dispatch(getPhotographerInvoiceCollectionSuccess(result));
        });
}

export function getHistoricInvoiceCollection(photographerInvoiceCollectionId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getHistoricInvoiceCollection(photographerInvoiceCollectionId).then((result: any) => {
            dispatch(getPhotographerInvoiceCollectionSuccess(result));
        });
}

export function savePendingInvoiceCollection(checksums: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.savePendingInvoiceCollection(checksums).then((result: any) => {
            dispatch(getListsSuccess(result));
        });
}

export function createPaymentFile(collectionId: number, when?: Date) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.createPaymentFile(collectionId, when);
}

export function createPaymentFileV2(collectionId: number, when?: Date) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.createPaymentFileV2(collectionId, when);
}
